import { render, staticRenderFns } from "./TravelerForm.vue?vue&type=template&id=71d8b68c&scoped=true"
import script from "./TravelerForm.vue?vue&type=script&lang=ts"
export * from "./TravelerForm.vue?vue&type=script&lang=ts"
import style0 from "./TravelerForm.vue?vue&type=style&index=0&id=71d8b68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8b68c",
  null
  
)

export default component.exports